const interiorHeaderAutoplayControls = document.querySelectorAll<HTMLElement>(
	'.block-interior-header__controls'
);

interiorHeaderAutoplayControls.forEach((autoplayControl) => {
	const iframe = autoplayControl.nextElementSibling?.querySelector<HTMLIFrameElement>('iframe');
	if (!iframe || iframe.tagName.toLowerCase() !== 'iframe') return;

	const player = new window.Vimeo.Player(iframe);

	const autoPlayBtn = autoplayControl.querySelector<HTMLButtonElement>(
		'.block-interior-header__auto-play-pause'
	);

	autoPlayBtn?.addEventListener('click', async () => {
		const autoPlayIcon = autoPlayBtn.querySelector<HTMLElement>('span[class^=icon]');
		const isPaused = await player.getPaused();
		if (isPaused) {
			await player.play();
			autoPlayIcon?.classList.remove('icon-play');
			autoPlayIcon?.classList.add('icon-pause');
		} else {
			await player.pause();
			autoPlayIcon?.classList.remove('icon-pause');
			autoPlayIcon?.classList.add('icon-play');
		}
	});
});
